import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const MessagesIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Messages",
    children: /*#__PURE__*/_jsx("path", {
      d: "M29.34 5.71a2.83 2.83 0 0 0-2.49-2.51h-.01c-2.46-.42-5.3-.66-8.19-.66h-.63.03-.59c-2.89 0-5.72.24-8.48.7l.3-.04c-1.01.09-1.86.73-2.25 1.61v.02c2.06-.25 4.45-.4 6.88-.4h.54c3.03 0 6.01.25 8.9.73l-.31-.04c2.21.31 3.93 2.05 4.2 4.25v.02c.43 1.97.68 4.24.69 6.57v.28c0 1.47-.1 2.91-.28 4.33l.02-.17c.91-.4 1.55-1.24 1.65-2.24.41-1.88.65-4.03.66-6.24 0-2.21-.24-4.35-.69-6.42l.04.2v.02Zm-4.13 4.04a2.83 2.83 0 0 0-2.49-2.51h-.01c-2.46-.42-5.3-.66-8.19-.66h-.63.03-.58c-2.89 0-5.72.24-8.48.7l.3-.04a2.83 2.83 0 0 0-2.51 2.49c-.42 1.88-.66 4.03-.66 6.24s.24 4.35.7 6.42l-.04-.2a2.83 2.83 0 0 0 2.49 2.51h.01c1.71.3 3.73.52 5.79.59h.08l2.17 3.76c.15.25.42.42.74.42s.59-.17.74-.42 2.17-3.76 2.17-3.76c2.13-.08 4.15-.29 6.13-.63l-.27.04a2.82 2.82 0 0 0 2.51-2.48c.41-1.88.65-4.03.66-6.24 0-2.21-.24-4.35-.69-6.42l.04.2Z"
    })
  }));
};